// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app[data-v-049307f6] {
  font-family: 'AvenirNextLTW01-Regular';
  font-size: 14px;
}
.app .data[data-v-049307f6] {
  color: #333;
  float: right;
}
.app table[data-v-049307f6] {
  border-collapse: collapse;
}
.app .data-row[data-v-049307f6] {
  color: #666;
  padding: 5px 0px;
}
.app .adjust-date[data-v-049307f6] {
  margin-top: 5px;
}
.com-mod-level-2-disclosure[data-v-049307f6] {
  font-size: 12px;
  font-family: 'AvenirNextLTW01-Condens 721299', Arial;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/Fees.vue","webpack://./Fees.vue"],"names":[],"mappings":"AACA;EACC,sCAAA;EACA,eAAA;ACAD;ADFA;EAIE,WAAA;EACA,YAAA;ACCF;ADNA;EAQE,yBAAA;ACCF;ADTA;EAWE,WAAA;EACA,gBAAA;ACCF;ADbA;EAeE,eAAA;ACCF;ADEA;EACC,eAAA;EACA,oDAAA;EACA,WAAA;ACAD","sourcesContent":["\n.app {\n\tfont-family: 'AvenirNextLTW01-Regular';\n\tfont-size: 14px;\n\t.data {\n\t\tcolor: #333;\n\t\tfloat: right;\n\t}\n\ttable {\n\t\tborder-collapse: collapse;\n\t}\n\t.data-row {\n\t\tcolor: #666;\n\t\tpadding: 5px 0px;\n\t}\n\t.adjust-date {\n\t\tmargin-top: 5px;\n\t}\n}\n.com-mod-level-2-disclosure {\n\tfont-size: 12px;\n\tfont-family: 'AvenirNextLTW01-Condens 721299', Arial;\n\tcolor: #666;\n}\n",".app {\n  font-family: 'AvenirNextLTW01-Regular';\n  font-size: 14px;\n}\n.app .data {\n  color: #333;\n  float: right;\n}\n.app table {\n  border-collapse: collapse;\n}\n.app .data-row {\n  color: #666;\n  padding: 5px 0px;\n}\n.app .adjust-date {\n  margin-top: 5px;\n}\n.com-mod-level-2-disclosure {\n  font-size: 12px;\n  font-family: 'AvenirNextLTW01-Condens 721299', Arial;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
